/**
 * Сервис для транскрибации аудио и AI обработки текста
 */
import { apiClient } from './api';

export const transcriptionService = {
  /**
   * Транскрибация аудио без сохранения
   */
  async transcribeAudio(audioBlob, mimeType) {
    const formData = new FormData();
    
    // Создаем имя файла на основе MIME типа
    const extension = mimeType.includes('mp4') ? 'mp4' : 
                     mimeType.includes('webm') ? 'webm' : 'ogg';
    const filename = `voice_note_${Date.now()}.${extension}`;
    
    formData.append('file', audioBlob, filename);
    
    console.log('[transcriptionService] Отправка аудио на транскрибацию...');
    console.log('[transcriptionService] Размер:', audioBlob.size, 'байт');
    console.log('[transcriptionService] MIME:', mimeType);
    
    const response = await apiClient.post('/transcription/audio', formData);
    
    if (response.success && response.text) {
      console.log('[transcriptionService] Транскрибация успешна, длина:', response.text.length);
      return response.text;
    }
    
    throw new Error('Не удалось получить транскрипцию');
  },
  
  /**
   * AI обработка текста заметок с извлечением notification
   * @returns {Promise<{text: string, notification: {date: string, time: string, event: string} | null}>}
   */
  async processText(text) {
    console.log('[transcriptionService] Отправка текста на AI обработку...');
    console.log('[transcriptionService] Длина текста:', text.length);
    
    const response = await apiClient.post('/transcription/process-text', { text });
    
    if (response.success && response.text) {
      console.log('[transcriptionService] AI обработка успешна, длина:', response.text.length);
      if (response.notification) {
        console.log('[transcriptionService] Notification найдена:', response.notification);
      }
      return {
        text: response.text,
        notification: response.notification || null
      };
    }
    
    throw new Error('Не удалось обработать текст');
  }
};
